// extracted by mini-css-extract-plugin
export default {"icon-links":"styles_icon-links__3XJ0a","link-item":"styles_link-item__036Ws"};